const Menu = [
	{ is_header: true, title: 'Navigation' },
	{ path: '/dashboard', icon: 'bi bi-speedometer2', title: 'Dashboard', requiredRole: 'admin' },
	{ is_divider: true }, 
	{ is_header: true, title: 'Tests (Universal)' }, 
	{ path: '/small-pentest', icon: 'bi bi-cpu', title: 'Small Pentest', requiredRole: 'user' },
	{ path: '/cron-tests', icon: 'bi bi-clock-history', title: 'Cron Tests', requiredRole: 'superuser' },
	{ path: '/agents', icon: 'bi bi-people', title: 'Agents', requiredRole: 'superuser'},
	{ is_divider: true }, 
	{ is_header: true, title: 'Tests (Windows-like)' },
	{ path: '/ai-tools', icon: 'bi bi-wrench-adjustable-circle', title: 'AI Tools', requiredRole: ['admin', 'superuser']},
	{ path: '/orchestrations', icon: 'bi bi-diagram-3', title: 'Orchestrations', requiredRole: ['admin', 'superuser']},
	{ is_divider: true }, 
	{ is_header: true, title: 'Additional' }, 
	{ path: '/aichat', icon: 'bi bi-robot', title: 'AI Chat', requiredRole: 'user'},	
	{ path: '/documentation', icon: 'bi bi-book', title: 'Documentation', requiredRole: 'user'},
	// Removed Test Notifications from sidebar menu per request
	{ is_divider: true },
	{ is_header: true, title: 'Admin' },
	{ 
		path: '/admin/users', 
		icon: 'bi bi-people-fill', 
		title: 'User Management',
		requiredRole: 'admin'
	},
	{ 
		path: '/admin/policies', 
		icon: 'bi bi-shield-lock', 
		title: 'Policies',
		requiredRole: 'admin'
	},
	{ 
		path: '/admin/settings', 
		icon: 'bi bi-sliders', 
		title: 'Admin Settings',
		requiredRole: 'admin'
	},
	{ 
		path: '/admin/statistics', 
		icon: 'bi bi-bar-chart-fill', 
		title: 'Statistics & Analytics',
		requiredRole: 'admin'
	},
	{ 
		path: '/admin/activity-logs', 
		icon: 'bi bi-clipboard-data', 
		title: 'Activity Logs',
		requiredRole: 'admin'
	},
	{ 
		path: '/admin/login-attempts', 
		icon: 'bi bi-key', 
		title: 'Login Attempts',
		requiredRole: 'admin'
	}
];

export default Menu;